import types from '../constants/invoiceConstants';
import { fromJS } from 'immutable';
import { mergeImmutableMap } from 'utils/immutableMerge';

const INITIAL_STATE = {
  active_notification: [],
  isLoading: false,
};
const initialImmutableState = fromJS(INITIAL_STATE);
const invoiceReducer = (state = initialImmutableState, action = {}) => {
  switch (action.type) {
    case types.SET_REDIRECTURL:
      return state.withMutations((mutableState) => {
        mutableState.set('redirectURL', fromJS(action.payload));
      });
    case types.GET_INVOICE_LIST:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'invoiceData',
          mergeImmutableMap(mutableState.get('invoiceData'), {
            isLoading: true,
            invoiceListError: null,
          }),
        );
      });
    case types.SET_INVOICE_LIST:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'invoiceData',
          fromJS({ ...action.payload, isLoading: false, invoiceListError: null }),
        );
      });
    case types.SET_INVOICE_LIST_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'invoiceData',
          mergeImmutableMap(mutableState.get('invoiceData'), {
            isLoading: false,
            invoiceListError: action.payload || 'Unable to load invoices.',
          }),
        );
      });
    case types.GET_INVOICE_LINE_LIST:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'invoiceLineData',
          mergeImmutableMap(mutableState.get('invoiceLineData'), {
            isLoading: true,
            lineListError: null,
          }),
        );
      });
    case types.SET_INVOICE_LINE_LIST:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'invoiceLineData',
          fromJS({ ...action.payload, isLoading: false, lineListError: null }),
        );
      });
    case types.SET_INVOICE_LINE_LIST_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'invoiceLineData',
          mergeImmutableMap(mutableState.get('invoiceLineData'), {
            isLoading: false,
            lineListError: action.payload || 'Unable to load invoice lines.',
          }),
        );
      });
    case types.GET_INVOICE_DISPUTE_HISTORY_LIST:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'invoiceDisputeHistoryData',
          mergeImmutableMap(mutableState.get('invoiceDisputeHistoryData'), {
            isLoading: true,
            disputeHistoryListError: null,
          }),
        );
      });
    case types.SET_INVOICE_DISPUTE_HISTORY_LIST:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'invoiceDisputeHistoryData',
          fromJS({ ...action.payload, isLoading: false, disputeHistoryListError: null }),
        );
      });
    case types.SET_INVOICE_DISPUTE_HISTORY_LIST_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'invoiceDisputeHistoryData',
          mergeImmutableMap(mutableState.get('invoiceDisputeHistoryData'), {
            isLoading: false,
            disputeHistoryListError: action.payload || 'Unable to load dispute history.',
          }),
        );
      });
    case types.GET_INVOICE_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'invoiceDetailData',
          fromJS({ data: null, isLoading: true, hasError: false }),
        );
      });
    case types.SET_INVOICE_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'invoiceDetailData',
          fromJS({ data: action.payload, isLoading: false, hasError: false }),
        );
      });
    case types.SET_INVOICE_DETAIL_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'invoiceDetailData',
          fromJS({ data: null, isLoading: false, hasError: true }),
        );
      });
    case types.SET_INVOICE_PDF:
      return state.withMutations((mutableState) => {
        mutableState.set('invoicePDF', fromJS(action.payload));
      });
    case types.SET_PDF_LOADING:
      return state.withMutations((mutableState) => {
        mutableState.set('pdf_loading', fromJS(action.payload));
      });
    case types.SET_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('error', fromJS(action.payload));
      });
    case types.SEND_DISPUTE:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'disputeSubmit',
          fromJS({
            isSubmitting: true,
            showSuccessModal: false,
            hasClaimFiledReason: false,
          }),
        );
      });
    case types.SEND_DISPUTE_SUCCESS:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'disputeSubmit',
          fromJS({
            isSubmitting: false,
            showSuccessModal: true,
            hasClaimFiledReason: Boolean(action.payload?.hasClaimFiledReason),
          }),
        );
      });
    case types.SEND_DISPUTE_ERROR:
    case types.CLEAR_DISPUTE_SUCCESS:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'disputeSubmit',
          fromJS({
            isSubmitting: false,
            showSuccessModal: false,
            hasClaimFiledReason: false,
          }),
        );
      });
    case types.SET_INVOICE_POLICY:
      return state.withMutations((mutableState) => {
        mutableState.set('application', fromJS(action.payload));
      });
    case types.SEARCH_SPINNER:
      return state.withMutations((mutableState) => {
        mutableState.set('searchSpinner', fromJS(action.payload));
      });
    default:
      return state;
  }
};

export default invoiceReducer;
